import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import InputAdornment from "@mui/material/InputAdornment";
import Typography from "@mui/material/Typography";
import Stack from "@mui/material/Stack";
import Snackbar from "@mui/material/Snackbar";
import Alert from "@mui/material/Alert";
import SearchOutlinedIcon from "@mui/icons-material/SearchOutlined";
import EmailOutlinedIcon from "@mui/icons-material/EmailOutlined";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import { portalStart, requestOtp } from "../../services/api/portal";
import { writePortalSession } from "../../lib/storage/portalSession";
import { normalizeError } from "../../services/http/errors";

export default function PortalStart() {
  const { portalSlug = "" } = useParams();
  const nav = useNavigate();
  const [orderNumber, setOrderNumber] = useState("");
  const [email, setEmail] = useState("");
  const [toast, setToast] = useState({ open: false, msg: "" });

  useEffect(() => {
    portalStart(portalSlug).catch(() => {});
  }, [portalSlug]);

  const submit = async () => {
    try {
      await requestOtp(portalSlug, orderNumber, email);
      writePortalSession({ portalSlug, orderNumber, email, verified: false, sessionToken: null, selectedItemIds: [] });
      nav(`/r/${portalSlug}/verify`);
    } catch (e) {
      const err = normalizeError(e);
      setToast({ open: true, msg: err.message });
    }
  };

  return (
    <>
      <Snackbar open={toast.open} autoHideDuration={3000} onClose={() => setToast({ open: false, msg: "" })} anchorOrigin={{ vertical: "top", horizontal: "center" }}>
        <Alert severity="error" onClose={() => setToast({ open: false, msg: "" })} variant="filled">
          {toast.msg}
        </Alert>
      </Snackbar>

      <Card sx={{ maxWidth: 480, width: "100%", position: "relative", overflow: "visible", "&::before": { content: '""', position: "absolute", top: 0, left: 16, right: 16, height: 4, borderRadius: 2, bgcolor: "primary.main" } }}>
        <CardContent sx={{ p: { xs: 3, sm: 4 } }}>
          <Stack spacing={3}>
            <div>
              <Typography variant="h5" gutterBottom>
                Hello again!
              </Typography>
              <Typography variant="body2" color="text.secondary">
                Enter your order details to manage your return
              </Typography>
            </div>

            <TextField
              label="Order Number"
              placeholder="e.g. #55412"
              fullWidth
              value={orderNumber}
              onChange={(e) => setOrderNumber(e.target.value)}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchOutlinedIcon fontSize="small" color="action" />
                  </InputAdornment>
                ),
              }}
            />

            <TextField
              label="Email Address"
              placeholder="customer@example.com"
              fullWidth
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <EmailOutlinedIcon fontSize="small" color="action" />
                  </InputAdornment>
                ),
              }}
            />

            <Button
              variant="contained"
              size="large"
              fullWidth
              onClick={submit}
              disabled={!orderNumber || !email}
              endIcon={<ArrowForwardIcon />}
            >
              Track My Order
            </Button>
          </Stack>
        </CardContent>
      </Card>
    </>
  );
}
